import { VerificationMethodModel } from "../otp/otp.model";

export class AuthorizeRequest {
    response_type: string;
    scope: string;
    client_id: string;
    state: string;
    code_challenge: string;
    code_challenge_method: string;
    redirect_uri: string;
    lang: string;
    companyId: number;
}

export class LoginParams {
    state: string;
    code: string;
}

export class AuthorizationResponse {
    redirectURI: string;
}

export class ConsentRequest {
    clientId: string;
    scopes: Scope[];

    constructor(clientId: string, scopes: Scope[]) {
        this.clientId = clientId;
        this.scopes = scopes;
    }
}

export class Scope {
    scopeId: number;
    allow: boolean;
    constructor(scopeId: number, allow: boolean) {
        this.scopeId = scopeId;
        this.allow = allow;
    }
}

export class ChangePhoneRequest {
  verifiedToken?: string;
  countryCallingCode: string;
  countryISO2: string;
  phone: string;
}

export class ChangePhoneResponse {
  status: string;
  verification?: RequiredVerifyUserResponse;
}

export class RequiredVerifyUserResponse {
  token: string;
  methods: VerificationMethodModel[];
}



// WEBPACK FOOTER //
// ./src/app/model/authen/authen.ts